
<template>
  <div class="tripartiteLink">
      <iframe :src="url" frameborder="0" height="100%" width="100%"></iframe>
      <img src="./../../assets/school/linkBack.png" @click="goBack()">
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: "",
    };
  },
  mounted() {
    if (this.$route.query.url) {
      this.url = this.$route.query.url;
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="less">
body{
    overflow:hidden;
}
.tripartiteLink {
  height: 100%;
  background-color: #f5f5f5;
  img{
      width: 82px;
      height: 32px;
      position: fixed;
      right: 0;
      bottom: 161px;
  }
}
</style>